import { Form, Row } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import InputFields from "../../../common/components/InputFields";
import getConfigs from "../../../GetConfigs";

const CaseSummaryPerson = ({ ...props }) => {
  const { form } = props;
  const configurations = getConfigs([
    "ctCityName",
    "ctDOB",
    "ctInsurance",
    "ctAddress",
    "ctLicense",
    "ctLicPlate"
  ]);

  return (
    <BannerCard title="Personal Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="NAME" formItemLabel="Name" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="INSURANCE" formItemLabel="Insurance" condition={configurations.ctInsurance} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 24, sm: 24, xs: 24 }} formItemName="ADDRESS1" formItemLabel="Address" condition={configurations.ctAddress} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 24, sm: 24, xs: 24 }} formItemName="CITY_STATE_ZIP" formItemLabel="City, State, Zip" condition={configurations.ctAddress} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="DATE_OF_BIRTH" formItemLabel="Date of Birth" condition={configurations.ctDOB} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="DRIVERS_LICENSE" formItemLabel="Drivers License" condition={configurations.ctLicense} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="LICENSE_PLATE" formItemLabel="License Plate" condition={configurations.ctLicPlate} />
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CaseSummaryPerson;
